import * as React from 'react';

import { AppHostIframe } from './Hosts/app-host-iframe';
import { useCreateAppHostSdk } from './Hosts/use-create-app-host-sdk';
import { IMetaOsAppContainerProps } from './meta-os-app-container.interface';
import { AppInitState } from './Services/hosted-web-content-sdk.interface';
import { IframeCommunicationBridge } from './Communication/iframe-communication-bridge';
import { UserSettingTypes } from './Services/messages.interface';

export const MetaOsAppContainer: React.FC<IMetaOsAppContainerProps> = (props: IMetaOsAppContainerProps) => {
  const frameContext = props.context.page.frameContext;
  const { appHostSdk, appInitInfo } = useCreateAppHostSdk(
    props.hostWindow,
    props.context,
    props.hubServices,
    props.appDefinition,
    props.isolationProvider?.communicationBridge ?? getDefaultCommunicationBridge(),
    props.telemetrySink
  );

  const theme = props.context.app.theme;
  React.useEffect(() => {
    if (theme) {
      appHostSdk.onThemeChanged && appHostSdk.onThemeChanged(theme);
      appHostSdk.onUserSettingsChanged && appHostSdk.onUserSettingsChanged(UserSettingTypes.theme, theme);
    }
  }, [theme]);

  const fileOpenPreference = props.context.app.userFileOpenPreference;

  React.useEffect(() => {
    if (fileOpenPreference) {
      appHostSdk.onUserSettingsChanged &&
        appHostSdk.onUserSettingsChanged(UserSettingTypes.fileOpenPreference, fileOpenPreference);
    }
  }, [fileOpenPreference]);

  React.useEffect(() => {
    appHostSdk.initializeAuthenticationContext(props.context);
  }, [props.context]);

  React.useEffect(() => {
    return function cleanup() {
      appHostSdk.unloadApp(props.appDefinition);
    };
  }, [props.appDefinition]);

  React.useEffect(() => {
    return function cleanup() {
      appHostSdk.unloadSDK();
    };
  }, []);

  if (appInitInfo.state === AppInitState.Failed) {
    return (
      (props.hubServices.hubUiService?.getErrorUi &&
        props.hubServices.hubUiService?.getErrorUi(appInitInfo.reason)) || <div></div>
    );
  }

  const isLoading = appInitInfo.state === AppInitState.Loading;

  const renderedHost = () => {
    const hostProps = {
      ...props,
      sdkHost: appHostSdk,
      isLoading,
      frameContext,
      userClickTime: props.context.app.userClickTime ?? Date.now(),
    };
    if (props.isolationProvider) {
      return props.isolationProvider.renderHost(hostProps);
    } else {
      return <AppHostIframe {...hostProps} />;
    }
  };

  return (
    <>
      {isLoading && props.hubServices.hubUiService.getLoadingUi()}
      {renderedHost()}
    </>
  );
};

export const getDefaultCommunicationBridge = () => new IframeCommunicationBridge();
